// extracted by mini-css-extract-plugin
export default {"container":"QRCodeSignupLink_container__K-NOO","qr":"QRCodeSignupLink_qr__FI8+q"};